export default __webpack_public_path__ + "static/index_reason_bg-edf32bcd9aa19460c41a64244a2bb03b.png";